import { FC } from 'react';
import {
  ReferenceField,
  CreateButton,
  Datagrid,
  EditButton,
  List,
  TextField,
  TopToolbar,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить jivo чат" />
  </TopToolbar>
);

export const JivoChatList: FC = () => (
  <List title="Список jivo чатов" filter={{}} actions={<ListActions />}>
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      <TextField source="name" label="Имя" />
      <TextField source="provider_id" label="Ресурс" />
      <TextField source="start_message" label="Стартовое сообщение" />
      <ReferenceField source="model_id" reference="models" label="Модель">
        <TextField source="name" />
      </ReferenceField>
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
